/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'
import { messages } from './main'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/gas',
          name: 'gas',
          component: () => import('./views/pages/Header.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Gas List', active: true}
            ],
            pageTitle: 'Gas'
          }
        },
        {
          path: '/gas/:uuid',
          name: 'gas-detail',
          component: () => import('./views/pages/Gas/Detail.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Gas Detalle', active: true}
            ],
            pageTitle: 'Gas'
          }
        },
        {
          path: '/gas/:uuid/history',
          name: 'gas-history',
          component: () => import('./views/pages/Gas/History.vue'),
          meta: {
            breadcrumb: [
              { title: 'home', url: '/home' },
              { title: 'Gas History', active: true}
            ],
            pageTitle: 'Gas'
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/pages/Dashboard.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/dashboard' }],
            pageTitle: 'Dashboard'
          }
        },
        {
          path: '/map',
          name: 'map',
          component: () => import('./views/pages/Map.vue'),
          meta: {
            breadcrumb: [{ title: 'Home', url: '/map' }],
            pageTitle: 'Map'
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/pages/Profile.vue'),
          meta: {
            breadcrumb: [{ title: 'Profile', url: '/profile' }],
            pageTitle: 'Profile'
          }
        }
      ]
    },
    
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.AppActiveUser.token.length > 0) {
    if (to.path === '/' || to.path === '/forgot-password' || (store.state.AppActiveUser.userRole !== 'MA' && to.matched.some(record => record.meta.rule === 'admin'))) {
      window.location.href = '/gas'
    } else {
      messages().then(() => next())
    }
  } else if (to.path === '/' || to.path === '/forgot-password') {
    messages().then(() => next())
  } else {
    window.location.href = '/'
  }

})

export default router
